import { useEffect, useState } from "react";

const NotificationToast = ({ title, body, onClick = () => {}, close = () => {} }) => {
  const [isVisible, setIsVisible] = useState(false); // Start with false for fade-in effect

  useEffect(() => {
    const fadeInTimer = setTimeout(() => {
      setIsVisible(true);
    }, 10); // Small delay to allow CSS transition to apply

    const fadeOutTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        close();
      }, 1000); // Wait for fade-out animation duration
    }, 5000);

    return () => {
      clearTimeout(fadeInTimer);
      clearTimeout(fadeOutTimer);
    };
  }, [close]);

  return (
    <div className="fixed top-0 left-0 w-full flex items-center justify-center pt-4 z-[9999]">
      <div
        onClick={onClick}
        className="flex items-start justify-between min-w-[70vw] max-w-[90vw] bg-[var(--primary-dark)] text-[var(--neutral-white)] py-3 pl-4 pr-2 rounded-lg shadow-lg cursor-pointer"
        style={{
          opacity: isVisible ? 1 : 0,
          transition: "opacity 1s",
        }}
      >
        <div className="flex flex-col">
          <span className="font-bold text-base">{title}</span>
          {body && <span className="text-sm pt-1">{body}</span>}
        </div>
        <img
          className="pl-2 pt-1"
          src={"/Assets/Images/crossIcon.svg"}
          alt="Close icon"
          onClick={(event) => {
            event.stopPropagation();
            close();
          }}
        />
      </div>
    </div>
  );
};

export default NotificationToast;
